export default __webpack_public_path__ + "static/media/coders.89e27da6.png";